/* ===== ELENNI WISHLIST 20260925 ===== */
(function (window, document) {
  'use strict';

  var STORAGE_KEY = 'elenni_wishlist_v1';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
      }
    } catch (e) {}
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function moneyAud(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { items: [] };
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.items)) return { items: [] };
      return data;
    } catch (e) {
      return { items: [] };
    }
  }

  function write(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    document.dispatchEvent(new CustomEvent('elenni:wishlist:updated', { detail: data }));
  }

  function itemKey(item) {
    return String(item.variantId || item.id || item.productId);
  }

  function findIndex(items, id) {
    var sid = String(id);
    for (var i = 0; i < items.length; i++) {
      if (itemKey(items[i]) === sid) return i;
    }
    return -1;
  }

  function has(id) {
    return findIndex(read().items, id) >= 0;
  }

  function upsertFromButton(btn) {
    var id = btn.getAttribute('data-wishlist-id');
    if (!id) return;
    var data = read();
    var idx = findIndex(data.items, id);
    if (idx >= 0) {
      data.items.splice(idx, 1);
    } else {
      data.items.push({
        id: String(id),
        productId: btn.getAttribute('data-product-id') || '',
        variantId: btn.getAttribute('data-variant-id') || String(id),
        handle: btn.getAttribute('data-handle') || '',
        title: btn.getAttribute('data-title') || '',
        url: btn.getAttribute('data-url') || '',
        sku: btn.getAttribute('data-sku') || '',
        image: btn.getAttribute('data-image') || '',
        price: Number(btn.getAttribute('data-price') || 0),
        available: btn.getAttribute('data-available') !== 'false',
        qty: 1,
        addedAt: Date.now()
      });
    }
    write(data);
  }

  function removeId(id) {
    var data = read();
    var idx = findIndex(data.items, id);
    if (idx >= 0) {
      data.items.splice(idx, 1);
      write(data);
    }
  }

  function syncButtons(rootEl) {
    var scope = rootEl || document;
    var data = read();
    scope.querySelectorAll('[data-elenni-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-id');
      var on = findIndex(data.items, id) >= 0;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('title', on ? 'Remove from wishlist' : 'Add to wishlist');
      var label = btn.querySelector('.elenni-wishlist-toggle__label');
      if (label && !label.classList.contains('visually-hidden')) {
        label.textContent = on ? 'In wishlist' : 'Add to wishlist';
      }
    });
  }

  function syncCounts() {
    var n = read().items.length;
    document.querySelectorAll('[data-elenni-wishlist-count]').forEach(function (bubble) {
      if (n > 0) {
        bubble.removeAttribute('hidden');
        bubble.classList.add('cart-link__bubble--visible');
      } else {
        bubble.setAttribute('hidden', '');
        bubble.classList.remove('cart-link__bubble--visible');
      }
    });
    document.querySelectorAll('[data-elenni-wishlist-count-num]').forEach(function (el) {
      el.textContent = String(n);
    });
  }

  function selectedItems(pageRoot) {
    var data = read();
    if (!pageRoot) return data.items.slice();
    var checks = pageRoot.querySelectorAll('[data-elenni-wishlist-select]:checked');
    if (!checks.length) return data.items.slice();
    var ids = {};
    checks.forEach(function (c) { ids[String(c.value)] = true; });
    return data.items.filter(function (it) { return ids[itemKey(it)]; });
  }

  function addToCart(items, goCheckout) {
    if (!items.length) {
      alert('Your wishlist is empty.');
      return Promise.resolve();
    }
    var payload = {
      items: items.map(function (it) {
        return {
          id: Number(it.variantId || it.id),
          quantity: Number(it.qty) || 1
        };
      })
    };
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (err) {
          throw new Error((err && (err.description || err.message)) || 'Could not add to cart');
        });
      }
      return r.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
      window.location.href = goCheckout ? (root + 'checkout') : (root + 'cart');
    }).catch(function (err) {
      alert(err.message || 'Could not add wishlist items to cart.');
    });
  }

  function pageRoot() {
    return document.querySelector('[data-elenni-wishlist-page]');
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* Brisbane-local parts via Intl (no extra deps). */
  function brisbaneParts(date) {
    var d = date || new Date();
    var fmt = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Brisbane',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    var parts = {};
    fmt.formatToParts(d).forEach(function (p) {
      if (p.type !== 'literal') parts[p.type] = p.value;
    });
    return parts;
  }

  function makeQuoteMeta() {
    var p = brisbaneParts();
    var y = p.year || '0000';
    var m = p.month || '01';
    var day = p.day || '01';
    var h = (p.hour || '00').replace(/^24$/, '00');
    var min = p.minute || '00';
    var ref = 'WL-' + y + m + day + '-' + h + min;
    var dateLabel = day + '/' + m + '/' + y + ' ' + h + ':' + min + ' (Australia/Brisbane)';
    return { ref: ref, dateLabel: dateLabel, y: y, m: m, day: day, h: h, min: min };
  }

  function customerFromForm(form) {
    function val(sel) {
      var el = form.querySelector(sel);
      return el ? String(el.value || '').trim() : '';
    }
    return {
      name: val('[name="contact[name]"]'),
      email: val('[name="contact[email]"]'),
      phone: val('[name="contact[phone]"]')
    };
  }

  function absUrl(url) {
    if (!url) return '';
    if (url.indexOf('http') === 0) return url;
    return window.location.origin + url;
  }

  function lineTotalCents(it) {
    return (Number(it.price) || 0) * (Number(it.qty) || 1);
  }

  function padRight(str, width) {
    str = String(str == null ? '' : str);
    if (str.length >= width) return str.slice(0, width);
    return str + Array(width - str.length + 1).join(' ');
  }

  function padLeft(str, width) {
    str = String(str == null ? '' : str);
    if (str.length >= width) return str.slice(0, width);
    return Array(width - str.length + 1).join(' ') + str;
  }

  function buildEmailBody(items, customer, meta) {
    var lines = [];
    lines.push('WISHLIST QUOTE - elenni.com.au');
    lines.push('Ref: ' + (meta && meta.ref ? meta.ref : ''));
    lines.push('Date: ' + (meta && meta.dateLabel ? meta.dateLabel : ''));
    lines.push('');
    lines.push('CUSTOMER');
    lines.push('Name: ' + ((customer && customer.name) || ''));
    lines.push('Email: ' + ((customer && customer.email) || ''));
    lines.push('Phone: ' + ((customer && customer.phone) || ''));
    lines.push('');
    lines.push('ITEMS');
    lines.push(
      padRight('#', 3) +
      padRight('Product', 32) +
      padRight('SKU', 18) +
      padLeft('Qty', 5) +
      padLeft('Unit', 12) +
      padLeft('Line', 12)
    );
    var subtotal = 0;
    if (!items.length) {
      lines.push('(Wishlist was empty when submitted)');
    } else {
      items.forEach(function (it, i) {
        var qty = Number(it.qty) || 1;
        var unit = Number(it.price) || 0;
        var line = unit * qty;
        subtotal += line;
        var title = String(it.title || 'Product');
        if (title.length > 30) title = title.slice(0, 27) + '...';
        var sku = String(it.sku || '');
        if (sku.length > 16) sku = sku.slice(0, 16);
        lines.push(
          padRight(String(i + 1), 3) +
          padRight(title, 32) +
          padRight(sku, 18) +
          padLeft(String(qty), 5) +
          padLeft(moneyAud(unit), 12) +
          padLeft(moneyAud(line), 12)
        );
      });
    }
    lines.push('');
    lines.push('SUBTOTAL  ' + moneyAud(subtotal));
    lines.push('FINAL PRICE  ' + moneyAud(subtotal));
    lines.push('');
    lines.push('PRODUCT LINKS');
    if (!items.length) {
      lines.push('(none)');
    } else {
      items.forEach(function (it, i) {
        lines.push((i + 1) + '. ' + absUrl(it.url));
      });
    }
    lines.push('');
    lines.push('Wishlist enquiry from elenni.com.au - quote request, not a confirmed order. Reply to the customer email.');
    return lines.join('\n');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fillQuotePanel(items, customer, meta) {
    var panel = document.getElementById('elenni-wishlist-quote');
    if (!panel) return;
    customer = customer || {};
    meta = meta || makeQuoteMeta();
    var rows = (items || []).map(function (it, i) {
      var qty = Number(it.qty) || 1;
      var unit = Number(it.price) || 0;
      return '<tr><td>' + (i + 1) + '</td><td>' + escapeHtml(it.title || 'Product') +
        '</td><td>' + escapeHtml(it.sku || '') +
        '</td><td>' + qty + '</td><td>' + moneyAud(unit) + '</td><td>' + moneyAud(unit * qty) + '</td></tr>';
    }).join('');
    if (!rows) {
      rows = '<tr><td colspan="6">(No items)</td></tr>';
    }
    var sub = (items || []).reduce(function (s, it) { return s + lineTotalCents(it); }, 0);
    var custBits = [];
    if (customer.name) custBits.push(escapeHtml(customer.name));
    if (customer.email) custBits.push(escapeHtml(customer.email));
    if (customer.phone) custBits.push(escapeHtml(customer.phone));
    var custHtml = custBits.length
      ? '<section class="elenni-wishlist-quote__customer"><h3>Customer</h3><p>' + custBits.join('<br>') + '</p></section>'
      : '';
    panel.innerHTML =
      '<div class="elenni-wishlist-quote__inner">' +
      '<header class="elenni-wishlist-quote__header">' +
      '<h2>Wishlist Quote</h2>' +
      '<p class="elenni-wishlist-quote__meta">Ref: ' + escapeHtml(meta.ref) +
      '<br>Date: ' + escapeHtml(meta.dateLabel) + '</p>' +
      '</header>' +
      custHtml +
      '<table class="elenni-wishlist-quote__table"><thead><tr>' +
      '<th>#</th><th>Product</th><th>SKU</th><th>Qty</th><th>Unit</th><th>Line</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table>' +
      '<div class="elenni-wishlist-quote__totals">' +
      '<p class="elenni-wishlist-quote__subtotal">Subtotal <span>' + moneyAud(sub) + '</span></p>' +
      '<p class="elenni-wishlist-quote__final">Final price <span>' + moneyAud(sub) + '</span></p>' +
      '</div>' +
      '<footer class="elenni-wishlist-quote__footer">Enquiry from elenni.com.au - quote request, not a confirmed order.</footer>' +
      '</div>';
    panel.setAttribute('aria-hidden', 'false');
  }

  /* Fill quote panel then browser-print (logo from liquid print-only block). */

  function elenniHideHcaptchaBadgeForPrint() {
    var el = document.getElementById('shop-hcaptcha-badge-container');
    if (!el) return;
    if (!el.getAttribute('data-elenni-print-prev-display')) {
      el.setAttribute('data-elenni-print-prev-display', el.style.display || '');
    }
    el.style.setProperty('display', 'none', 'important');
  }
  function elenniRestoreHcaptchaBadgeAfterPrint() {
    var el = document.getElementById('shop-hcaptcha-badge-container');
    if (!el) return;
    var prev = el.getAttribute('data-elenni-print-prev-display');
    if (prev != null) {
      el.style.display = prev;
      el.removeAttribute('data-elenni-print-prev-display');
    } else {
      el.style.removeProperty('display');
    }
  }
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeprint', elenniHideHcaptchaBadgeForPrint);
    window.addEventListener('afterprint', elenniRestoreHcaptchaBadgeAfterPrint);
  }

  function prepareQuoteForPrint() {
    var page = pageRoot();
    var form = document.querySelector('#elenni-wishlist-email-form');
    var items = selectedItems(page);
    var customer = form ? customerFromForm(form) : { name: '', email: '', phone: '' };
    var meta = makeQuoteMeta();
    fillQuotePanel(items, customer, meta);
    return { items: items, customer: customer, meta: meta };
  }

  function prepareQuoteForSubmit(form) {
    var page = pageRoot();
    var items = selectedItems(page);
    var customer = customerFromForm(form);
    var meta = makeQuoteMeta();
    var body = form.querySelector('#elenni-wishlist-email-body');
    var subject = form.querySelector('#elenni-wishlist-email-subject') ||
      form.querySelector('[name="contact[subject]"]');

    if (subject) subject.value = 'Wishlist Quote ' + meta.ref + ' - elenni.com.au';
    fillQuotePanel(items, customer, meta);
    if (body) body.value = buildEmailBody(items, customer, meta);
    return Promise.resolve({ meta: meta });
  }

  function renderPage() {
    var page = document.querySelector('[data-elenni-wishlist-page]');
    if (!page) return;
    var list = page.querySelector('[data-elenni-wishlist-list]');
    var empty = page.querySelector('[data-elenni-wishlist-empty]');
    var countEl = page.querySelector('[data-elenni-wishlist-page-count]');
    var bodyField = page.querySelector('#elenni-wishlist-email-body');
    var data = read();
    if (countEl) countEl.textContent = String(data.items.length);

    if (!list) return;
    list.innerHTML = '';
    if (!data.items.length) {
      if (empty) empty.hidden = false;
      list.hidden = true;
    } else {
      if (empty) empty.hidden = true;
      list.hidden = false;
      data.items.forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'elenni-wishlist__item';
        li.setAttribute('data-wishlist-id', itemKey(it));
        var img = it.image
          ? '<img class="elenni-wishlist__item-img" src="' + it.image.replace(/"/g, '&quot;') + '" alt="" width="96" height="96" loading="lazy">'
          : '<div class="elenni-wishlist__item-img elenni-wishlist__item-img--placeholder" aria-hidden="true"></div>';
        var href = (it.url || '#').replace(/"/g, '&quot;');
        var title = (it.title || 'Product').replace(/</g, '&lt;');
        var sku = it.sku ? '<span class="elenni-wishlist__item-sku">SKU: ' + String(it.sku).replace(/</g, '&lt;') + '</span>' : '';
        /* Horizontal row: image left, details right (LTR title) */
        li.innerHTML =
          '<label class="elenni-wishlist__item-check"><input type="checkbox" data-elenni-wishlist-select value="' + itemKey(it) + '" checked></label>' +
          '<a class="elenni-wishlist__item-media" href="' + href + '">' + img + '</a>' +
          '<div class="elenni-wishlist__item-meta">' +
            '<a href="' + href + '">' + title + '</a>' +
            sku +
            '<span class="elenni-wishlist__item-price">' + money(it.price) + '</span>' +
          '</div>' +
          '<div class="elenni-wishlist__item-actions">' +
            '<button type="button" class="btn btn--secondary btn--small" data-elenni-wishlist-add-one="' + itemKey(it) + '">Add to cart</button>' +
            '<button type="button" class="btn btn--secondary btn--small" data-elenni-wishlist-remove="' + itemKey(it) + '">Remove</button>' +
          '</div>';
        list.appendChild(li);
      });
    }
    if (bodyField) {
      var form = document.querySelector('#elenni-wishlist-email-form');
      var customer = form ? customerFromForm(form) : { name: '', email: '', phone: '' };
      bodyField.value = buildEmailBody(data.items, customer, makeQuoteMeta());
    }
  }

  function onClick(e) {
    var t = e.target.closest('[data-elenni-wishlist-toggle]');
    if (t) {
      e.preventDefault();
      e.stopPropagation();
      upsertFromButton(t);
      return;
    }
    var page = document.querySelector('[data-elenni-wishlist-page]');
    if (!page) return;

    var rem = e.target.closest('[data-elenni-wishlist-remove]');
    if (rem) {
      e.preventDefault();
      removeId(rem.getAttribute('data-elenni-wishlist-remove'));
      return;
    }
    var one = e.target.closest('[data-elenni-wishlist-add-one]');
    if (one) {
      e.preventDefault();
      var id = one.getAttribute('data-elenni-wishlist-add-one');
      var items = read().items.filter(function (it) { return itemKey(it) === String(id); });
      addToCart(items, false);
      return;
    }
    if (e.target.closest('[data-elenni-wishlist-add-selected]')) {
      e.preventDefault();
      addToCart(selectedItems(page), false);
      return;
    }
    if (e.target.closest('[data-elenni-wishlist-checkout]')) {
      e.preventDefault();
      addToCart(selectedItems(page), true);
      return;
    }
    if (e.target.closest('[data-elenni-wishlist-print]')) {
      e.preventDefault();
      prepareQuoteForPrint();
      elenniHideHcaptchaBadgeForPrint(); window.print();
      return;
    }
    if (e.target.closest('[data-elenni-wishlist-clear]')) {
      e.preventDefault();
      if (confirm('Clear your wishlist?')) write({ items: [] });
      return;
    }
  }

  function emailStatus(form, message) {
    var status = form.querySelector('[data-elenni-wishlist-email-status]');
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
  }

  function captchaBound(form) {
    return form.dataset.hcaptchaBound === 'true' || form.dataset.recaptchaBound === 'true';
  }

  function captchaTokenValue(form) {
    var nodes = form.querySelectorAll(
      'textarea[name="h-captcha-response"], input[name="h-captcha-response"], ' +
      'textarea[name="g-recaptcha-response"], input[name="g-recaptcha-response"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var v = (nodes[i].value || '').trim();
      if (v) return v;
    }
    return '';
  }

  function captchaTokenPresent(form) {
    return !!captchaTokenValue(form);
  }

  /*
   * Shopify captcha-bootstrap binds contact forms on focusin/change. iOS autofill
   * can skip those, so prime early (DOM ready + focus/input) and optionally call
   * Shopify.captcha.protect. Never strip captcha; never use data-nocaptcha.
   */
  function waitForCaptchaBinding(form, callback) {
    if (captchaBound(form)) {
      callback(true);
      return;
    }
    form._elenniCaptchaWaiters = form._elenniCaptchaWaiters || [];
    form._elenniCaptchaWaiters.push(callback);
    if (form._elenniCaptchaPollActive) return;
    form._elenniCaptchaPollActive = true;

    var started = Date.now();
    function finish(ok) {
      if (!form._elenniCaptchaPollActive) return;
      form._elenniCaptchaPollActive = false;
      delete form.dataset.elenniCaptchaProtectRequested;
      var waiters = form._elenniCaptchaWaiters || [];
      form._elenniCaptchaWaiters = [];
      waiters.forEach(function (fn) { fn(ok); });
    }

    function poll() {
      if (captchaBound(form)) {
        finish(true);
        return;
      }
      if (Date.now() - started >= 6000) {
        finish(false);
        return;
      }
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function' &&
          !form.dataset.elenniCaptchaProtectRequested) {
        form.dataset.elenniCaptchaProtectRequested = 'true';
        try {
          captcha.protect(form, function () { poll(); });
        } catch (err) {
          delete form.dataset.elenniCaptchaProtectRequested;
        }
      }
      window.setTimeout(poll, 100);
    }
    poll();
  }

  function tryExecuteCaptcha(form) {
    /* Invisible widget must run execute() before a token appears. */
    try {
      var iframe = form.querySelector('[data-hcaptcha-widget-id]');
      var wid = iframe && iframe.getAttribute('data-hcaptcha-widget-id');
      var wrap = form.querySelector('.h-captcha');
      if (!wid && wrap) {
        wid = wrap.getAttribute('data-hcaptcha-widget-id') ||
          (wrap.dataset && wrap.dataset.hcaptchaWidgetId) || null;
      }
      if (window.hcaptcha && typeof window.hcaptcha.execute === 'function') {
        if (wid != null && wid !== '') window.hcaptcha.execute(wid);
        else window.hcaptcha.execute();
        return true;
      }
    } catch (err) {}
    try {
      if (window.grecaptcha && typeof window.grecaptcha.execute === 'function') {
        window.grecaptcha.execute();
        return true;
      }
    } catch (err2) {}
    return false;
  }

  function waitForCaptchaToken(form, callback) {
    if (captchaTokenPresent(form)) {
      callback(true);
      return;
    }
    form._elenniTokenWaiters = form._elenniTokenWaiters || [];
    form._elenniTokenWaiters.push(callback);
    if (form._elenniTokenPollActive) return;
    form._elenniTokenPollActive = true;

    var started = Date.now();
    var executed = false;

    function finish(ok) {
      if (!form._elenniTokenPollActive) return;
      form._elenniTokenPollActive = false;
      var waiters = form._elenniTokenWaiters || [];
      form._elenniTokenWaiters = [];
      waiters.forEach(function (fn) { fn(ok); });
    }

    function poll() {
      if (captchaTokenPresent(form)) {
        finish(true);
        return;
      }
      if (Date.now() - started >= 10000) {
        finish(false);
        return;
      }
      if (captchaBound(form) && !executed) {
        executed = tryExecuteCaptcha(form);
      }
      window.setTimeout(poll, 150);
    }

    waitForCaptchaBinding(form, function () {
      if (!executed) executed = tryExecuteCaptcha(form);
      poll();
    });
  }

  function primeEmailCaptcha(form) {
    if (!form || form.dataset.elenniCaptchaPrimed === 'true') return;
    form.dataset.elenniCaptchaPrimed = 'true';
    form.setAttribute('data-shopify-captcha', 'true');
    form.removeAttribute('data-nocaptcha');

    function kick() {
      try {
        var nameInput = form.querySelector('[name="contact[name]"]') ||
          form.querySelector('input, textarea');
        if (nameInput) {
          nameInput.dispatchEvent(new Event('focusin', { bubbles: true }));
          nameInput.dispatchEvent(new Event('focus', { bubbles: true }));
        }
        form.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) {}
      waitForCaptchaBinding(form, function () {});
    }

    kick();
    form.addEventListener('focusin', function () { kick(); }, true);
    form.addEventListener('input', function () {
      if (!captchaBound(form)) kick();
    }, true);
  }

  /*
   * Allow-through submit: requestSubmit (not prototype.submit) so Shopify
   * captcha-bootstrap can inject the token on the real submit event.
   * Flag elenniCaptchaResubmitting lets the second submit pass unblocked.
   */
  function requestNativeEmailSubmit(form) {
    form.dataset.elenniCaptchaResubmitting = 'true';
    try {
      var submitter = form.querySelector('button[type="submit"], input[type="submit"]');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter || undefined);
      } else if (submitter) {
        submitter.click();
      } else {
        /* Last resort — prefer never; captcha may miss token. */
        HTMLFormElement.prototype.submit.call(form);
      }
    } catch (err) {
      delete form.dataset.elenniCaptchaResubmitting;
      emailStatus(form, 'Could not send - please try again');
    }
  }

  function continueCaptchaThenSubmit(form) {
    emailStatus(form, 'One moment - confirming...');
    waitForCaptchaToken(form, function (ok) {
      delete form.dataset.elenniQuotePending;
      if (!ok) {
        emailStatus(form, 'Couldn\'t verify - tap Email again');
        return;
      }
      emailStatus(form, 'Verified - sending...');
      requestNativeEmailSubmit(form);
    });
  }

  /*
   * Flow: first submit prevented → prepareQuote (no download/attach)
   * → wait captcha token → requestSubmit allow-through so Shopify injects token.
   * Never data-nocaptcha. Never prototype.submit as the happy path.
   */
  function onSubmit(e) {
    var form = e.target.closest('#elenni-wishlist-email-form');
    if (!form) return;

    /* Second pass: let Shopify captcha + native POST through. */
    if (form.dataset.elenniCaptchaResubmitting === 'true') {
      delete form.dataset.elenniCaptchaResubmitting;
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.dataset.elenniQuotePending === 'true') return;
    form.dataset.elenniQuotePending = 'true';

    primeEmailCaptcha(form);
    emailStatus(form, 'Preparing quote...');
    prepareQuoteForSubmit(form).then(function () {
      continueCaptchaThenSubmit(form);
    }).catch(function () {
      continueCaptchaThenSubmit(form);
    });
  }

  function bindVariantSync() {
    document.addEventListener('variant:change', function (ev) {
      var detail = ev.detail || {};
      var variant = detail.variant || detail;
      if (!variant || !variant.id) return;
      document.querySelectorAll('.elenni-wishlist-toggle--pdp').forEach(function (btn) {
        btn.setAttribute('data-wishlist-id', String(variant.id));
        btn.setAttribute('data-variant-id', String(variant.id));
        if (variant.sku != null) btn.setAttribute('data-sku', variant.sku);
        if (variant.price != null) btn.setAttribute('data-price', String(variant.price));
        if (variant.available != null) btn.setAttribute('data-available', variant.available ? 'true' : 'false');
        syncButtons(btn.parentNode || document);
      });
    });
  }

  function boot() {
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('elenni:wishlist:updated', function () {
      syncButtons();
      syncCounts();
      renderPage();
    });
    bindVariantSync();
    syncButtons();
    syncCounts();
    renderPage();
    var emailForm = document.querySelector('#elenni-wishlist-email-form');
    if (emailForm) primeEmailCaptcha(emailForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ElenniWishlist = {
    read: read,
    has: has,
    removeId: removeId,
    addToCart: addToCart
  };
})(window, document);
/* ===== END ELENNI WISHLIST 20260925 ===== */
